/* Author M. Atoar Rahman
 * Title: Facility Stock Receive
 * Description: Page for Facility Stock Receive
 * Date: 27/06/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { FacilityStockReceiveProvider } from '../facility/stockReceive/ContextAPI';
import Index from '../facility/stockReceive/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityStockReceive() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-stock-receive']) return <PermissionDenied />;

    return (
        <FacilityStockReceiveProvider>
            <Index />
        </FacilityStockReceiveProvider>
    );
}
